/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import { toChildArray } from 'preact';
import { HTMLAttributesSignalExcluded } from '../utils/UNSAFE_attributeUtils';
import type { BoxAlignmentProps } from '../utils/UNSAFE_interpolations/boxalignment';
import { layersStackStyles } from './themes/TimeComponentStyles.css';
import { Size } from '../utils/UNSAFE_size';

type IntrinsicProps = Pick<HTMLAttributesSignalExcluded<HTMLDivElement>, 'children'>;
type Props = IntrinsicProps &
  Omit<BoxAlignmentProps, 'gap'> & {
    width?: Size;
    height?: Size;
  };

export function TimeComponentLayersStack({ width, height, children, align, justify }: Props) {
  const layers = toChildArray(children);
  return (
    <div
      class={layersStackStyles.base}
      style={{ width, height, alignItems: align, justifyItems: justify }}>
      {layers.map((layer) => (
        <div class={layersStackStyles.layer}>{layer}</div>
      ))}
    </div>
  );
}
